import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { Environment, ENVIRONMENT } from 'libs/core/src/public-api';
import {
  LoginComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  RegisterComponent,
  SetPasswordComponent,
  setPasswordGuard,
} from '../public-api';

export function createAuthRoutes(): Routes {
  const environment = inject<Environment>(ENVIRONMENT);

  const routes: Routes = [
    {
      path: '',
      children: [
        {
          path: 'login',
          component: LoginComponent,
        },
        {
          path: 'forgot-password',
          component: ForgotPasswordComponent,
        },
        {
          path: 'password-reset',
          component: ResetPasswordComponent,
        },
        {
          path: 'set-password',
          canActivate: [setPasswordGuard],
          component: SetPasswordComponent,
        },
        {
          path: '**',
          redirectTo: 'login',
        },
      ],
    },
  ];

  // Conditionally add register route
  if (environment.APP_TYPE === 'cms') {
    routes[0].children?.splice(1, 0, {
      path: 'register',
      component: RegisterComponent,
    });
  }

  return routes;
}
